<template>
  <div>
    <h1>Help Page</h1>

  </div>
</template>

<script>
export default {
  name: 'HelpPage'
}
</script>
